import { cn } from "../../lib/cn";

import MLB from "../../images/new-design/teams/mlb.png";
import NHL from "../../images/new-design/teams/nhl.png";
import MLS from "../../images/new-design/teams/mls.png";
import NWSL from "../../images/new-design/teams/nwsl.png";
import NFL from "../../images/new-design/teams/nfl.png";
import NBA from "../../images/new-design/teams/nba.png";
import WNBA from "../../images/new-design/teams/wnba.png";
import BASK from "../../images/new-design/teams/bask.png";

const images = [
  {
    id: 0,
    image: MLB,
    alt: "Major League Baseball (MLB) logo",
  },
  {
    id: 1,
    image: NHL,
    alt: "National Hockey League (NHL) logo",
  },
  {
    id: 2,
    image: MLS,
    alt: "Major League Soccer (MLS) logo",
  },
  {
    id: 3,
    image: NWSL,
    alt: "National Women's Soccer League (NWSL) logo",
  },
  {
    id: 4,
    image: NFL,
    alt: "National Football League (NFL) logo",
  },
  {
    id: 5,
    image: NBA,
    alt: "National Basketball Association (NBA) logo",
  },
  {
    id: 6,
    image: WNBA,
    alt: "Women's National Basketball Association (WNBA) logo",
  },
  {
    id: 7,
    image: BASK,
    alt: "Basketball league logo",
  },
];

function Teams() {
  return (
    <section
      className={cn(["bg-background pt-[88px] lg:pt-[174px] overflow-hidden"])}
      aria-label="Professional sports leagues we serve"
    >
      <style>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-scroll {
          animation: scroll 30s linear infinite;
        }
        .ticker-wrapper:hover .animate-scroll {
          animation-play-state: paused;
        }
      `}</style>
      <div
        className="ticker-wrapper flex"
        role="region"
        aria-label="Sports leagues carousel"
      >
        <div className="animate-scroll flex gap-16 px-10">
          {images.map((item) => (
            <img
              key={item.id}
              alt={item.alt}
              src={item.image}
              className="w-auto h-auto object-contain flex-shrink-0"
              loading="lazy"
              width="auto"
              height="auto"
            />
          ))}
          {/* Duplicate for seamless loop */}
          {images.map((item) => (
            <img
              key={`duplicate-${item.id}`}
              alt={item.alt}
              src={item.image}
              className="w-auto h-auto object-contain flex-shrink-0"
              loading="lazy"
              width="auto"
              height="auto"
              aria-hidden="true"
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export { Teams };
